import React, { useState } from 'react';
import styles from './SuccessModal.module.css';
import {Close, ContentCopy, Visibility, VisibilityOff } from '@mui/icons-material';
import { TextField, IconButton } from '@mui/material';

const SuccessModal = ({ 
  isOpen, 
  onClose, 
  newUserEmail, 
  generatedPassword,
  onCopyEmail,
  onCopyPassword,
  onCopyCredentials
}) => {
  const [showPassword, setShowPassword] = useState(false);
  
  return (
    <>
      {isOpen && (
        <div className={styles.modalOverlay} onClick={onClose}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h2>User Created Successfully!</h2>
              <button className={styles.closeButton} onClick={onClose}>
                <Close fontSize="small" />
              </button>
            </div>

            <div className={styles.successContent}>
              <div className={styles.successIcon}>✓</div>
              <h3>User credentials have been created</h3>
              <p>Please share these credentials with the new team member:</p>
              
              <div className={styles.credentialsContainer}>
                <div className={styles.credentialItem}>
                  <label>Email:</label>
                  <div className={styles.credentialValue} style={{ padding: 0, border: 'none', background: 'none' }}>
                    <TextField
                      variant="outlined"
                      size="small"
                      value={newUserEmail}
                      InputProps={{
                        readOnly: true,
                        style: {
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          background: '#fff',
                          padding: '10px 12px',
                          fontSize: '15px',
                          flex: 1,
                        },
                      }}
                      style={{ flex: 1, minWidth: 0 }}
                      inputProps={{ style: { padding: '6px 0 6px 8px', fontFamily: 'Fira Mono, Consolas, Courier New, monospace' } }}
                    />
                    <IconButton onClick={onCopyEmail} size="small" style={{ marginLeft: 8 }}>
                      <ContentCopy fontSize="small" />
                    </IconButton>
                  </div>
                </div>
                
                <div className={styles.credentialItem}>
                  <label>Password:</label>
                  <div className={styles.credentialValue} style={{ padding: 0, border: 'none', background: 'none' }}>
                    <TextField
                      variant="outlined"
                      size="small"
                      value={generatedPassword}
                      type={showPassword ? 'text' : 'password'}
                      InputProps={{
                        readOnly: true,
                        style: {
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          background: '#fff',
                          padding: '10px 12px',
                          fontSize: '15px',
                          flex: 1,
                        },
                        endAdornment: (
                          <IconButton onClick={() => setShowPassword(v => !v)} size="small">
                            {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                          </IconButton>
                        )
                      }}
                      style={{ flex: 1, minWidth: 0 }}
                      inputProps={{ style: { padding: '6px 0 6px 8px', fontFamily: 'Fira Mono, Consolas, Courier New, monospace' } }}
                    />
                    <IconButton onClick={onCopyPassword} size="small" style={{ marginLeft: 8 }}>
                      <ContentCopy fontSize="small" />
                    </IconButton>
                  </div>
                </div>
              </div>

              <div className={styles.successActions}>
                <button 
                  type="button" 
                  onClick={onCopyCredentials}
                  className={styles.copyCredentialsButton}
                >
                  <ContentCopy fontSize="small" /> Copy Credentials
                </button>
                <button className={styles.closeSuccessButton} onClick={onClose}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SuccessModal; 